import styled, {keyframes} from 'styled-components';
import ShieldIcon from '../../../stories/Icons/ShieldIcon';
import {
  SmallSectionHeader,
  BaseColumnWrap,
  ButtonBase,
} from '../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const HomeBodyWrapperSection = styled(BaseColumnWrap)(
  props => `
    background-color: ${props.theme.colors.ash.medium};
    position: relative;
  `,
);

export const HomeBodyWrapperContentDiv = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 120rem;
    margin: 0 auto;
  `,
);

export const HomePageTitle = styled.h1(
  props => `
  font-size: ${props.theme.font.custom(22)};
  font-family: ${props.theme.font.fontFamily};
  font-weight:bold;
  z-index:${props.theme.misc.zIndex.xlarge};
  color: ${props.theme.colors.goWhite.base};
  margin: ${props.theme.spacing.xlarge} 0;
  `,
);

export const BackBlueRoundDark = styled.div(
  props => `
      width: 111rem;
      height: 95rem;
      background-color: ${props.theme.colors.goBrandBlue.base};
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      top: -53rem;
      left: -69rem;
      transform: translate(50%);
      z-index: ${props.theme.misc.zIndex.xxsmall};
  `,
);

export const BackBlueRoundLight = styled.div(
  props => `
      width: 117rem;
      height: 100rem;
      background-color: ${props.theme.colors.goBrandBlue.medium};
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      top: -58rem;
      left: -76rem;
      transform: translate(50%);
  `,
);

export const SearchBlockOuterWrapper = styled.section(
  props => `
    width: 100%;
    display: flex;
    margin-bottom: ${props.theme.spacing.custom(44)};
  `,
);

export const AdsUIWrapper = styled.div(
  props => `
    width: 100%;
  `,
);

export const ExploreBtnText = styled(SmallSectionHeader)(
  props => `
  color: ${props.theme.colors.goWhite.base};
  padding-right:${props.theme.spacing.base};
  `,
);

const AnimateUpDown = keyframes`
    0%   { transform: translateY(0); }
    50%  { transform: translateY(-20px); }
    100% { transform: translateY(0); }
`;

export const ExploreMoreBtn = styled(ButtonBase)`
  position: relative;
  top: 3rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  text-transform: capitalize;
  width: fit-content;
  background-image: linear-gradient(105deg, #1149f3, #00c3ff 100%);
  padding: ${props => props.theme.spacing.custom(14)} ${props => props.theme.spacing.xlarge};
  border-radius: ${props => props.theme.misc.borderRadius.custom(26)};
  animation-name: ${AnimateUpDown};
  animation-duration: 1s;
  animation-iteration-count: 3;
  transform-origin: bottom;
  animation-timing-function: linear;
`;
